import { Controller } from '@hotwired/stimulus';

export default class InternationalServicesController extends Controller {
  static outlets = ['modal'];

  showModal({ params }) {
    this.modalOutlet.open(params.modalId);
  }
}
